var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestaurant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.454 17.8552L12.2195 9.62062L2.59891 0H1.84705L1.69353 0.3901C1.28834 1.41976 1.11521 2.47287 1.19294 3.43547C1.28153 4.53272 1.69837 5.48268 2.39847 6.18278L9.90884 13.6931L10.8994 12.7025L17.8428 20.4665C18.5335 21.1572 19.7223 21.1982 20.454 20.4665C21.174 19.7465 21.174 18.5751 20.454 17.8552Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42788 11.9537L0.545789 17.8358C-0.174117 18.5557 -0.174117 19.7272 0.545789 20.4471C1.22968 21.131 2.41278 21.1914 3.15705 20.4471L9.03918 14.565L6.42788 11.9537Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1082 3.49663L16.7715 6.83325L15.901 5.96281L19.2377 2.62615L18.3673 1.75572L15.0306 5.09234L14.1602 4.22191L17.4969 0.885285L16.6265 0.0148926L12.2743 4.36706C11.7419 4.89948 11.424 5.60643 11.379 6.35775C11.3677 6.54811 11.3245 6.73534 11.2529 6.91343L14.0801 9.7406C14.2582 9.66895 14.4455 9.62584 14.6358 9.61448C15.3871 9.56965 16.094 9.25165 16.6265 8.71923L20.9786 4.3671L20.1082 3.49663Z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.458bbe99.svg";
export { ForwardRef as ReactComponent };